/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).on('click', '.cv_custom_mobile_Search_inner .header__action-item-link', function(e){
  e.preventDefault();
  $('.cv_mobile_search_header_Wrapper').toggleClass('cv_custom_mobile_Search_field');
  $('.header__search-bar-wrapper').toggleClass('is-visible');

});

$(document).on('click', '.cv_custom_Create_account', function(e){
e.preventDefault();
$('.popover__panel-list').addClass('cv_custom_create_Acc');
$('.popover__panel-list').removeClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');

var cv_custom_attr = $('#account-popover').attr('aria-hidden');
if(cv_custom_attr == 'true'){
$('#account-popover').attr('aria-hidden','false');
}else{
$('#account-popover').attr('aria-hidden','true');
}
$('.cv_register_panel').addClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').removeClass('is-selected');

});

$(document).on('click', '.cv_cross_bottom_create_Acocunt_popup_toggle', function(){
$('.popover__panel-list').addClass('cv_custom_create_Acc');
$('.popover__panel-list').removeClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');
// $('#account-popover').toggleClass('cv_custom_Acount_popover');
// $('#account-popover').toggleAttr('aria-hidden', "true");
var cv_custom_attr = $('#account-popover').attr('aria-hidden');
if(cv_custom_attr == 'true'){
$('#account-popover').attr('aria-hidden','false');
}else{
$('#account-popover').attr('aria-hidden','true');
}
$('.cv_register_panel').addClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').removeClass('is-selected');

});

$(document).on('click', '.cv_custom_my_Account', function(e){
e.preventDefault();
$('.popover__panel-list').removeClass('cv_custom_create_Acc');
$('.popover__panel-list').addClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');
var cv_custom_att = $('#account-popover').attr('aria-hidden');
if(cv_custom_att == 'true'){
$('#account-popover').attr('aria-hidden','false');
}else{
$('#account-popover').attr('aria-hidden','true');
}
$('.cv_register_panel').removeClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').addClass('is-selected');

});


$(document).on('click', '.cv_cross_bottom_my_account_popup_toggle', function(){
$('.popover__panel-list').removeClass('cv_custom_create_Acc');
$('.popover__panel-list').addClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');
// $('#account-popover').toggleClass('cv_custom_Acount_popover');
// $('#account-popover').toggleAttr('aria-hidden', "true");
var cv_custom_att = $('#account-popover').attr('aria-hidden');
if(cv_custom_att == 'true'){
$('#account-popover').attr('aria-hidden','false');
}else{
$('#account-popover').attr('aria-hidden','true');
}
$('.cv_register_panel').removeClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').addClass('is-selected');

});

$(document).on('click', '.cv_custom_Recovery', function(){
$('.popover__panel-list').removeClass('cv_custom_create_Acc');
$('.popover__panel-list').removeClass('cv_custom_my_Accoun');
$('.popover__panel-list').addClass('cv_custom_recovery_popup');

$('#account-popover').toggleClass('cv_custom_Acount_popover');
// $('#account-popover').toggleAttr('aria-hidden', "true");

$('.cv_register_panel').removeClass('is-selected');
$('.cv_Recovery_panel').addClass('is-selected');

$('.cv_login_panel').removeClass('is-selected');

});

$(document).on('click', '.cv_custom_back_to_login', function(){
$('.popover__panel-list').removeClass('cv_custom_create_Acc');
$('.popover__panel-list').addClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');
$('#account-popover').toggleClass('cv_custom_Acount_popover');
// $('#account-popover').toggleAttr('aria-hidden', "true");

$('.cv_register_panel').removeClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').addClass('is-selected');

});

$(document).on('click', '.cv_custom_create_Acc', function(){
$('.popover__panel-list').addClass('cv_custom_create_Acc');
$('.popover__panel-list').removeClass('cv_custom_my_Accoun');
$('.popover__panel-list').removeClass('cv_custom_recovery_popup');
$('#account-popover').toggleClass('cv_custom_Acount_popover');
// $('#account-popover').toggleAttr('aria-hidden', "true");

$('.cv_register_panel').addClass('is-selected');
$('.cv_Recovery_panel').removeClass('is-selected');

$('.cv_login_panel').removeClass('is-selected');

});